import { render, staticRenderFns } from "./TheOverviewItem.vue?vue&type=template&id=1543d2dd"
import script from "./TheOverviewItem.vue?vue&type=script&lang=js"
export * from "./TheOverviewItem.vue?vue&type=script&lang=js"
import style0 from "./TheOverviewItem.vue?vue&type=style&index=0&id=1543d2dd&prod&lang=less&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports